import { FC, SVGProps } from 'react'

const BenchmarkIcon: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="benchmark-icon"
    {...svgProps}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 14.5534C11.6194 14.5534 14.5534 11.6194 14.5534 8C14.5534 4.38063 11.6194 1.44655 8 1.44655C4.38063 1.44655 1.44655 4.38063 1.44655 8C1.44655 11.6194 4.38063 14.5534 8 14.5534ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.51123 8.87234L5.17735 12.7146L6.48831 7.12692L6.48902 7.12734L10.8229 3.28511L9.51195 8.87276L9.51123 8.87234ZM8.00071 8.78349C8.43342 8.78349 8.7842 8.43271 8.7842 8C8.7842 7.56729 8.43342 7.21651 8.00071 7.21651C7.568 7.21651 7.21722 7.56729 7.21722 8C7.21722 8.43271 7.568 8.78349 8.00071 8.78349Z"
      fill="currentColor"
    />
  </svg>
)

export default BenchmarkIcon
